import axios from 'axios'
import { DocumentDeviceJobRecord, DocumentDevicesResponse, DocumentEnrollmentCreated } from '@numeo/types-core'

/** The message to show for a failed call: the server's own message when it sent one, else the fallback. */
/** Re-exported, not re-implemented — see `@/api/errorMessage`. Behaviour is unchanged. */
export { apiErrorMessage } from '@/api/errorMessage'

export const documentDevicesApi = {
    async getOverview(): Promise<DocumentDevicesResponse> {
        const res = await axios.get('/gluon/document-devices/v1')
        return res.data.data as DocumentDevicesResponse
    },

    /** The last 50 jobs this device claimed. */
    async getDeviceJobs(keyId: string): Promise<DocumentDeviceJobRecord[]> {
        const res = await axios.get(`/gluon/document-devices/${keyId}/jobs/v1`)
        return res.data.data.jobs as DocumentDeviceJobRecord[]
    },

    /** The only time the code and the install command can be seen: the server keeps only a hash. */
    async createEnrollment(label: string, ttlMinutes: number): Promise<DocumentEnrollmentCreated> {
        const res = await axios.post('/gluon/document-devices/enrollments/v1', { label, ttlMinutes })
        return res.data.data as DocumentEnrollmentCreated
    },

    async cancelEnrollment(codeId: string): Promise<void> {
        await axios.post('/gluon/document-devices/enrollments/cancel/v1', { codeId })
    },

    async revokeKey(keyId: string): Promise<void> {
        await axios.post('/gluon/document-devices/keys/revoke/v1', { keyId })
    },
}
